export interface User {
  id: string;
  name: string;
  email: string;
}

export interface UserRole {
  id: string;
  name: string;
  isMember: boolean;
}

export interface UserBusinessArea {
  id: string;
  name: string;
  isMember: boolean;
}

export interface UserRoleChange {
  userId: string;
  groupId: string;
}

export interface UserBusinessAreaChange {
  UserId: string;
  BusinessAreaId: string;
}

export interface UserToRemove {
  Id: string;
  Email: string;
}

export enum UserGroupName {
  Admin = 'SalesSupportPortal-Admin',
  Laundry = 'SalesSupportPortal-Laundry',
  Export = 'SalesSupportPortal-Export',
  Import = 'SalesSupportPortal-Import',
  Notifications = 'SalesSupportPortal-Notifications',
  Wellhung = 'SalesSupportPortal-Wellhung',
  EuConformity = 'SalesSupportPortal-EuConformity',
  DeliveryMethods = 'SalesSupportPortal-DeliveryMethods',
  Customers = 'SalesSupportPortal-Customers',
  Products = 'SalesSupportPortal-Products',
  NorceManagement = 'SalesSupportPortal-NorceManagement',
  Giveaway = 'SalesSupportPortal-Giveaway',
}

export interface UserGroup {
  id: string;
  name: string;
  isMember: boolean;
}

export interface Permission {
  id: string;
  name: string;
  key: string;
}

export enum StormRole {
  'User' = 64,
  'Administrator' = 65,
  'Internal' = 80,
  'CustomerAdmin' = 81,
  'B2C' = 111,
}
